var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 112,
    viewBox: "0 0 148 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8664 84.9053C38.2026 86.3105 35 84.3791 35 81.3674V4.4C35 1.96995 36.9308 0 39.3125 0H99.6875C102.069 0 104 1.96995 104 4.4V81.3674C104 84.3791 100.797 86.3105 98.1336 84.9053L71.3664 70.7846C70.1984 70.1685 68.8016 70.1685 67.6336 70.7846L40.8664 84.9053Z",
    fill: "url(#paint0_linear_18278_92760)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 15.3711H85.3143",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 27H4C3.44771 27 3 27.4477 3 28V32",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 45H4C3.44771 45 3 44.5523 3 44V40",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 45H20C20.5523 45 21 44.5523 21 44V40",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27H20C20.5523 27 21 27.4477 21 28V32",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 36H8",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40V32",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.44 32.9532C115.345 30.6883 112.116 30.6964 111.032 32.9669L106.683 42.0776C106.253 42.9779 105.404 43.6057 104.417 43.7525L94.3246 45.2545C91.8896 45.6169 90.9035 48.5959 92.6413 50.3396L100.065 57.7885C100.751 58.4769 101.061 59.455 100.897 60.4129L99.1679 70.507C98.7441 72.9803 101.363 74.8499 103.565 73.6454L112.282 68.8759C113.179 68.3851 114.264 68.385 115.162 68.8758L123.891 73.6509C126.091 74.8543 128.709 72.988 128.288 70.516L126.569 60.4093C126.407 59.4534 126.716 58.4778 127.4 57.7904L134.818 50.3345C136.553 48.5909 135.568 45.6156 133.136 45.2516L123.116 43.7521C122.135 43.6054 121.291 42.9837 120.859 42.0912L116.44 32.9532Z",
    fill: "url(#paint1_linear_18278_92760)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.664 55.4755L112.793 59.6042L121.05 51.3467",
    stroke: "white",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.424 95.6367C120.141 96.5155 119.5 97.97 119.5 100C119.5 103.045 122 107.838 126.5 109C129.404 109.75 132.794 109.75 135.5 109C139 108.03 140.5 105.362 140.5 103.045C140.5 99.7823 140.5 96.5196 140.5 93.2568C140.5 92.0142 139.493 91.0068 138.25 91.0068H138.243C137.004 91.0068 136 92.0112 136 93.25",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.484 97.3335V82.004C122.484 80.7624 123.491 79.7559 124.733 79.7559C124.735 79.7559 124.737 79.7559 124.739 79.7559C125.985 79.7593 126.993 80.7704 126.993 82.0165V93.6936",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.992 93.2562V90.2616C126.992 89.0126 128.005 88 129.254 88C130.503 88 131.515 89.0126 131.515 90.2616V93.2562",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 93.0372V91.0029C131.5 89.7603 132.507 88.7529 133.75 88.7529C134.993 88.7529 136 89.7603 136 91.0029V93.2529",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18278_92760",
    x1: 96,
    y1: -0.00000226212,
    x2: 35,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18278_92760",
    x1: 110,
    y1: 30.5,
    x2: 127,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4867D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowCover);
export default __webpack_public_path__ + "static/media/follow-cover.42d293192199af2460a7b6e0f275a477.svg";
export { ForwardRef as ReactComponent };